import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as SuccessIcon } from 'src/images/icon-success.svg'
import Page from '@components/Page'
import { getDateWithWeekDayAndTime } from 'src/utils/date'
import useCommonStyles from '@screens/OnlineCancellation/commonStyles'
import useStyles from './styles'

type SuccessStepProp = {
  date: Date
}

export const SuccessStep = ({ date }: SuccessStepProp) => {
  const { t } = useTranslation()
  const commonClasses = useCommonStyles()
  const { dateWithWeekDay, time } = getDateWithWeekDayAndTime(date)
  const classes = useStyles()

  return (
    <Page
      header={undefined}
      body={
        <div className={commonClasses.innerWrapper}>
          <div className={commonClasses.contentWrapper}>
            <SuccessIcon className={classes.icon} />
            <div className={classes.textContainer}>
              <div className={classes.header}>{t('success_cancellation_message')}</div>
              <div className={classes.description}>
                {t('cancellation_confirmation_message', {
                  date: dateWithWeekDay,
                  time,
                })}
              </div>
            </div>
          </div>
        </div>
      }
    />
  )
}
